module.exports = __webpack_public_path__ + "static/media/lizBus-01.e0b38c08.jpg";